import { render, staticRenderFns } from "./SelectOption.vue?vue&type=template&id=6b1bed3c&scoped=true&"
import script from "./SelectOption.vue?vue&type=script&lang=ts&"
export * from "./SelectOption.vue?vue&type=script&lang=ts&"
import style0 from "./SelectOption.vue?vue&type=style&index=0&id=6b1bed3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1bed3c",
  null
  
)

export default component.exports